let uid = 0;

export const getUid = () => (uid += 1);
